import { ImageFormat } from '../../idscan/enums/ImageFormat';
import { TranslationKey } from '../../idscan/enums/Translation';
import { IBase64Components } from '../interfaces/Images';
import { ExceptionManager } from './ExceptionManager';

/**
 * @internal
 */
export class ImageService {
	/**
	 * Base method that takes a blob and encodes it, then resolves a string.
	 * @param blob: Blob
	 */
	public static convert(blob: Blob): Promise<any> {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(blob);
			reader.onerror = (error) => {
				throw ExceptionManager.process(new ExceptionManager.PlatformException(TranslationKey.EXCEPTION_PLATFORM_UNSUPPORTED));
			};
			reader.onload = () => {
				resolve(reader.result);
			};
		});
	}

	/**
	 * Get the ImageFormat from the specified MIME Type
	 * @param mime - The MIME type to extract form
	 */
	public static resolveImageFormat(mime: string): ImageFormat {
		const [, subtype] = mime.split('/');

		return subtype as ImageFormat;
	}

	/**
	 * Extract the elements of the base64 string
	 *
	 * @param str - The string to process
	 */
	public static getBase64Components(str: string): IBase64Components {
		const [contentType = '', content = ''] = str.split(';');
		const [, type] = contentType.split(':');
		const [, data] = content.split(',');

		return { type: ImageService.resolveImageFormat(type), data };
	}

	/**
	 * Remap the names of an IBase64Component object for server consumption
	 *
	 * @param param0 - The type to remap
	 */
	public static remapNames({ data, type: imageFormat }: IBase64Components) {
		return { data, imageFormat };
	}
}
